module.exports = __webpack_public_path__ + "static/media/IMG20200307161944.45e56639.jpg";